import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Platform, MenuController, App} from 'ionic-angular';
import { ServiceProvider } from '../../providers/service/service';
import { Storage } from '@ionic/storage';
import { AlertController, Nav, ToastController, LoadingController ,ModalController} from 'ionic-angular';
import { ViewController } from 'ionic-angular'

//@IonicPage()
@Component({
  selector: 'page-enquiry-remark',
  templateUrl: 'enquiry-remark.html',
})
export class EnquiryRemarkPage {

  FEnquiryId:any;
  EnquiryRemarkData:any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public service: ServiceProvider, public platform:Platform, menuCtrl:MenuController, public loadingCtrl: LoadingController, public toastCtrl: ToastController,public alertCtrl: AlertController,private modalCtrl: ModalController,public storage: Storage,public _app: App, public viewCtrl: ViewController) {
    this.platform.ready().then(() => {

      this.FEnquiryId = navParams.get('FEnquiryId');
      console.log(this.FEnquiryId);

      this.get_enquiry_remark(this.FEnquiryId);
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EnquiryRemarkPage');
  }

  get_enquiry_remark(FEnquiryId){
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();
    setTimeout(() => {
      loading.dismiss();
    }, 5000);
    this.service.httpcall('web_service/get_enquiry_remark?params[Id]='+FEnquiryId).subscribe(data => {
      loading.dismiss();
      console.log(data);
      this.EnquiryRemarkData = data;
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.get_enquiry_remark(this.FEnquiryId);
    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  goBack(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/enquiry-remark/enquiry-remark.ts